import React from 'react';
import Modal from '../../../Common/Components/Modal';
import { AuditActionsProps } from '../../../types/AuditActionsProps';

function AuditActions(props: AuditActionsProps): JSX.Element {
  const { setShowModal, selectedRecordIdItems } = props;

  return (
    <div className="alarm-playbook">
      <Modal
        title="Record Items"
        width="344"
        setModalOpen={() => setShowModal(0)}
        primaryButtonAction={() => setShowModal(0)}
        secondaryButtonAction={() => setShowModal(0)}
        primaryButtonLabel="OK"
        secondaryButtonLabel="Cancel"
      >
        <div className="content">
          <div className="content-text">
            <div>
              {selectedRecordIdItems}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default AuditActions;
